import { blackListService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    suspected_ips: {},
    black_ips: {}
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    suspected_ips(state, suspected_ips) {
        state.status = 'success'
        state.suspected_ips = suspected_ips
    },

    black_ips(state, black_ips) {
        state.status = 'success'
        state.black_ips = black_ips
    },
}

const getters = {
    status: ({status}) => status,
    suspected_ips: ({suspected_ips}) => suspected_ips,
    black_ips: ({black_ips}) => black_ips,
}

const actions = {
    fetchSuspectedIps({commit}) {
        commit('loading')
        return blackListService.fetchSuspectedIps().then(response => {
            commit('suspected_ips', response.data.data)
        })
    },
    fetchBlackIps({commit}) {
        commit('loading')
        return blackListService.fetchBlackIps().then(response => {
            commit('black_ips', response.data.data)
        })
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}